import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../admin/App'
import '../admin/styles/admin.css'

const container = document.getElementById('app')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container) // Create a root.
root.render(<App />) // Use the root to render the App.